import { MeasurementWatcher } from '../containers/MeasurementWatcher/MeasurementWatcher'

export const MeasurementWatcherPage = () => (
    <MeasurementWatcher/>
)